import { Controller, useFormContext } from 'react-hook-form'
import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
  Tooltip,
} from '@material-ui/core'

import constants from 'constants/index'

import useStyles from './styles'

const SolutionController = ({ solution, groupFieldName }) => {
  const classes = useStyles()

  const { control, errors, watch } = useFormContext()

  const allValues = watch()
  const groupValue = allValues[groupFieldName ?? '']

  const { SOLUTION_MANAGEABLE, STATUSES } = constants.dai.solutions

  const isGroupOnly =
    solution.manageable === SOLUTION_MANAGEABLE.GROUP_ONLY && !!groupFieldName

  const isChecked = isGroupOnly
    ? groupValue !== STATUSES.DISABLED
    : allValues[solution.tag] !== STATUSES.DISABLED

  const handleStatusChange = (checked) =>
    checked ? STATUSES.ENABLED : STATUSES.DISABLED

  if (isGroupOnly) {
    return (
      <FormControl fullWidth>
        <FormControlLabel
          label={solution.name}
          labelPlacement="start"
          className={classes.formControlLabel}
          control={
            <Tooltip title="Esta solução é gerenciada pelo grupo e não pode ser configurada individualmente.">
              <Box className={classes.lockedBox}>
                <Switch checked={isChecked} color="primary" disabled />
              </Box>
            </Tooltip>
          }
        />
      </FormControl>
    )
  }

  return (
    <Controller
      as={
        <FormControl fullWidth>
          <FormControlLabel
            label={solution.name}
            labelPlacement="start"
            className={classes.formControlLabel}
            control={<Switch checked={isChecked} color="primary" />}
          />
          {!!errors?.[solution.tag] && (
            <FormHelperText error>
              {errors?.[solution.tag]?.message}
            </FormHelperText>
          )}
        </FormControl>
      }
      control={control}
      name={solution.tag}
      onChange={([event]) => handleStatusChange(event.target.checked)}
    />
  )
}

export default SolutionController
